import {defineField, defineType} from 'sanity'
import {BiFileBlank} from 'react-icons/bi'

export default defineType({
  name: 'blog.post',
  title: 'Post',
  type: 'document',
  icon: BiFileBlank,
  groups: [{name: 'content', default: true}, {name: 'cruises'}, {name: 'metadata'}],
  fields: [
    defineField({
      name: 'title',
      type: 'string',
      group: 'content',
      validation: (Rule) => Rule.required(),
    }),
    defineField({
      name: 'featuredMedia',
      type: 'image',
      group: 'content',
      options: {hotspot: true, metadata: ['lqip']},
    }),
    defineField({
      name: 'excerpt',
      type: 'portableText',
      group: 'content',
    }),
    defineField({
      name: 'content',
      type: 'portableTextContent',
      group: 'content',
    }),
    defineField({
      name: 'publishDate',
      type: 'date',
      group: 'content',
      validation: (Rule) => Rule.required(),
    }),
    defineField({
      name: 'mainCategory',
      type: 'reference',
      to: [{type: 'blog.category'}],
      validation: (Rule) => Rule.required(),
      group: 'content',
    }),
    defineField({
      name: 'tags',
      type: 'array',
      of: [{type: 'reference', to: [{type: 'blog.tag'}]}],
      validation: (Rule) => Rule.required().min(1).max(10).unique(),
      group: 'content',
    }),
    defineField({
      name: 'authors',
      type: 'array',
      of: [{type: 'reference', to: [{type: 'blog.author'}]}],
      validation: (Rule) => Rule.required().min(1).unique(),
      group: 'content',
    }),
    defineField({
      name: 'relatedPosts',
      title: 'Related Articles (read next)',
      type: 'array',
      of: [{type: 'reference', to: [{type: 'blog.post'}], weak: true}],
      group: 'content',
    }),
    defineField({
      name: 'cruiseFilters',
      type: 'cruise-filters',
      group: 'cruises',
    }),
    defineField({
      name: 'metadata',
      type: 'metadata',
      group: 'metadata',
    }),
    defineField({
      name: 'wpId',
      type: 'number',
      title: 'WordPress ID',
      description: 'WordPress post ID for sync tracking',
      group: 'metadata',
      readOnly: true,
    }),
    defineField({
      name: 'wpOriginalUrl',
      type: 'string',
      title: 'WordPress Original URL',
      description: 'Original URL of the post in WordPress',
      group: 'metadata',
      readOnly: true,
    }),
  ],
  preview: {
    select: {
      title: 'title',
      subtitle: 'mainCategory.title',
      media: 'featuredMedia',
      description: 'publishDate',
    },
  },
})
